<div class="loads">
  <div class="header-bar">
    <div class="header-left">
      <h5>Loads</h5>
    </div>
    <div class="header-right">
      <div ngbDropdown class="d-inline-block" placement="bottom-right" #filterDrop="ngbDropdown">
        <button id="wave-allocation-filter-btn" class="fa fa-filter btn-primary mr-3" ngbDropdownToggle></button>
        <div ngbDropdownMenu aria-labelledby="dropdownForm1" class="filter-dropdown">
          <div>
            <div class="filter-box">
              <span class="ml-2">Customer Name or Code</span>
              <ov-suite-input
                class="customer-search"
                type="text"
                placeholder="Search"
                [(ngModel)]="dataService.loadsFilter.customerSearchTerm"
              >
              </ov-suite-input>
            </div>
            <div class="filter-box">
              <span class="ml-2">Date Range</span>
              <ov-suite-input
                #dateRange
                type="date-range"
                placeholder="Date Range"
                [(ngModel)]="dataService.loadsDateRange"
                hideClearButton="true"
              >
              </ov-suite-input>
            </div>
          </div>
          <div class="filter-button-bar">
            <button (click)="clearLoadsFilter()" class="btn-sm btn-secondary mb-2">Clear</button>
            <button (click)="filterChange(); filterDrop.close()" class="btn-sm btn-primary mb-2">Apply</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <table class="table table-striped">
    <thead>
      <tr>
        <th *ngFor="let col of dataService.loadPlanColumns" scope="col" (click)="onColumnHeaderClick(col.name)">
          {{ col.name }}
          <i *ngIf="dataService.sortingData.column !== col.name" class="fa fa-fw fa-sort" aria-hidden="true"></i>
          <i
            *ngIf="dataService.sortingData.column === col.name"
            class="fa fa-fw"
            [ngClass]="{
              'fa-sort-asc': dataService.sortingData.direction === 'ASC',
              'fa-sort-desc': dataService.sortingData.direction === 'DESC'
            }"
            aria-hidden="true"
          ></i>
        </th>
      </tr>
    </thead>
    <tbody
      cdkDropList
      id="load-list"
      class="wave-bay-plan"
      cdkDropListOrientation="horizontal"
      [cdkDropListData]="dataService.loads.value"
      [cdkDropListConnectedTo]="baseService.lists"
      (cdkDropListDropped)="actionService.drop($event, null, null)"
      [cdkDropListDisabled]="!baseService.permissions.create"
    >
      <tr
        *ngFor="let loadPlan of dataService.loads.value"
        [cdkDragData]="loadPlan"
        (click)="actionService.selectLoad(loadPlan.load)"
        class="wave-bay-pin"
        cdkDrag
      >
        <td>{{ loadPlan.load.id }}</td>
        <td>{{ loadPlan.load.getVehicle()?.registration }}</td>
        <td>{{ loadPlan.load.date }}</td>
        <td>{{ loadPlan.load.orders.length }}</td>
      </tr>
    </tbody>
  </table>
</div>
